<template>
  <div>
    <vendor-sign-up-modal
      @referVendor="referVendor($event)"
      :referVendorForm="true"
    />
    <div class="dashboard-card d-flex align-self-center">
      <div class="card-actions m-auto pt-5">
        <div
          class="btn btn-success"
          @click.prevent="openReferVendorForm"
										data-test="introduceVendorBtn"
										id="introduceVendorBtn"
        >
          Introduce a vendor
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { agentApis } from '@/services/ApiServices/agentApis'
import VendorSignUpModal from '@/components/pages/vendor/modals/vendorSignUpModal'

export default {
	components: {
		VendorSignUpModal
	},
	methods: {
		openReferVendorForm () {
			$('#SignupModal').modal('show')
		},
		async referVendor (vendorData) {
			try {
				await agentApis.referVendor(vendorData)
				this.$emit('vendorReferred', this.account)
				this.$root.$emit('vendorReferFormClear')
				$('#SignupModal').modal('hide')
			} catch (err) {
				this.$toasted.show(`Vendor refer failed. ${err.body.message}.`)
				// $('#SignupModal').modal('hide');
			}
		}
	}
}
</script>
